// LazyVideo.jsx
import { useRef, useState, useEffect } from 'react';

/**
 * LazyVideo
 * Props:
 *  - src: string            // video URL
 *  - poster: string         // thumbnail URL
 *  - isActive: boolean      // only load video when active
 *  - rootMargin: string     // IntersectionObserver rootMargin
 *  - controls, muted, autoPlay, loop: boolean
 *  - style, className: any  // optional styling
 */

export default function LazyVideo({ src, poster, isActive, rootMargin = '200px', controls = true, muted = false, autoPlay = false, loop = false, className = '', style = {},
}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Observe visibility
  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { rootMargin }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [rootMargin]);



  // When active: show container, inject video only when visible
  return (
    <div
      ref={ref}
      className={className}
      style={{
        position: 'relative',
        width: '100%',
        height: 0,
        paddingBottom: '56.25%', // 16:9
        ...style,
      }}
    >
      {isVisible && (
        <video
          src={src}
          poster={poster}
          controls={controls}
          muted={muted}
          autoPlay={autoPlay}
          loop={loop}
          preload="metadata"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          Your browser does not support HTML5 video.
        </video>
      )}
    </div>
  );
}
